module.exports = __webpack_public_path__ + "img/live_sense.c5438e30.jpg";